import { GenericListCall, SortOptions } from "../../components/types/web-types";
import {
  createRequest,
  updateRequest,
  postRequest,
  deleteRequest,
} from "../../web";
import {
  InactiveResidentsListCallIn,
  ResidentListCallIn,
  ResidentUpdateCallIn,
} from "./store/typesIn";
import { ResidentDataOut } from "./store/typesOut";

const resourceUrl = "/api/careplan/manage-clients";

const webCalls = {
  readAll(payload: GenericListCall) {
    return postRequest<GenericListCall, ResidentListCallIn>(
      `${resourceUrl}/list`,
      payload
    );
  },

  save(clientDefinition: ResidentDataOut) {
    return createRequest<ResidentDataOut, ResidentUpdateCallIn>(
      resourceUrl,
      clientDefinition
    );
  },

  update(clientDefinition: ResidentDataOut) {
    return updateRequest<ResidentDataOut, ResidentUpdateCallIn>(
      resourceUrl,
      clientDefinition
    );
  },

  remove(clientId: number) {
    return deleteRequest<
      {
        clientId: number;
      },
      null
    >(resourceUrl, {
      clientId,
    });
  },

  readAllInactive(sorted: SortOptions[]) {
    return postRequest<SortOptions[], InactiveResidentsListCallIn>(
      `${resourceUrl}/inactive-clients`,
      sorted
    );
  },

  removeInactive(clientId: number) {
    return deleteRequest<
      {
        clientId: number;
      },
      null
    >(`${resourceUrl}/inactive-clients`, {
      clientId,
    });
  },
};

export default webCalls;
